/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContactWithCustomListIds { 
    /**
     * Тип контакта
     */
    contactTypeId?: number;
    /**
     * Контакт для связи.
     */
    contact?: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * Приоритет.
     */
    isPriority?: boolean;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    isRequired?: boolean;
    /**
     * id справочника CustomList
     */
    customListId?: string;
    /**
     * Id значения из справочника CustomList
     */
    customListValueId?: string;
}

